module.exports = __webpack_public_path__ + "img/20180815_151844_197.f4ab00a6.jpg";